import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { store } from '@/store/store';
import { AppRoutes } from '@/routes/AppRoutes';
import { NavigationHistoryProvider } from '@/contexts/NavigationHistoryContext';
import { AdminAuthProvider } from '@/contexts/AdminAuthContext';

export default function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <AdminAuthProvider>
          <NavigationHistoryProvider>
            <AppRoutes />
          </NavigationHistoryProvider>
        </AdminAuthProvider>
      </BrowserRouter>
    </Provider>
  );
}